import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MaterialIcon from '../../components/admin/MaterialIcon';
import { MdOutlineChat, MdOutlineEmail } from 'react-icons/md';
import {
  HELP_SUPPORT_EMAIL,
  HELP_SUPPORT_MAILTO,
  HELP_SUPPORT_TELEGRAM_URL,
} from './helpArticles';

function HelpContacts({ classes }) {
  return (
    <Paper className={classes.paper} elevation={2} data-testid="admin-help-contacts">
      <Typography variant="h6" className={classes.title}>
        Поддержка
      </Typography>
      <div className={classes.actions}>
        <Button
          className={classes.actionBtn}
          variant="contained"
          color="primary"
          href={HELP_SUPPORT_TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MaterialIcon icon={MdOutlineChat} className={classes.actionIcon} size={20} />
          Чат с поддержкой
        </Button>
        <Button
          className={classes.actionBtn}
          variant="outlined"
          color="primary"
          href={HELP_SUPPORT_MAILTO}
        >
          <MaterialIcon icon={MdOutlineEmail} className={classes.actionIcon} size={20} />
          {HELP_SUPPORT_EMAIL}
        </Button>
      </div>
    </Paper>
  );
}

HelpContacts.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    boxSizing: 'border-box',
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  actionBtn: {
    textTransform: 'none',
    marginRight: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  actionIcon: {
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
});

export default withStyles(styles)(HelpContacts);
